import StoreModuleService from '../../../StoreModuleService';
import { initialState } from './state';

// mutations declarations

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
};

export default mutations;
